export const GET_IDENTIFICATIONS = "GET_IDENTIFICATIONS";
export const GET_IDENTIFICATION_BY_ID = "GET_IDENTIFICATION_BY_ID";
export const UPDATE_IDENTIFICATION = "UPDATE_IDENTIFICATION";
export const DELETE_IDENTIFICATION = "DELETE_IDENTIFICATION";
export const CREATE_IDENTIFICATION = "CREATE_IDENTIFICATION";
